import { lazyIsTeamsChatEnabled } from 'owa-teams-policies-lazy';

export async function isTeamsChatEnabled(): Promise<boolean> {
    return lazyIsTeamsChatEnabled.importAndExecute();
}
